<mat-form-field>
  <mat-label>
    @if (contracts.length === 0) {
      Aucun contrat éligible trouvé
    } @else {
      {{ label() }}
    }
  </mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    [disabled]="disabled"
    [required]="required"
    [compareWith]="compareContracts"
  >
    <mat-select-trigger>
      <div>
        @if (selectedContract) {
          {{ selectedContract.companyId | companyName }} - {{ selectedContract.contractType }} du
          {{ selectedContract.startDate | date }}
        }
      </div>
    </mat-select-trigger>
    @for (contract of contracts; track $index) {
      @let company = contract.companyId | companyIdToCompany;

      <mat-option
        [value]="contract.id"
        class="company-border"
        [style.borderColor]="company ? company.companyColor : 'unset'"
      >
        <div>
          {{ contract.companyId | companyName }} - {{ contract.contractType }}
          <div>
            <span class="indent">du {{ contract.startDate | date: 'shortDate' }}</span>
            @if (contract.endDate) {
              <span class="indent">au {{ contract.endDate | date: 'shortDate' }}</span>
            }
          </div>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
